<template>
    <div class="color-field color-field--hsb" v-if="true">
        <label class="color-field__label">HSB</label>
        <div class="color-field__meta editable-text">
            <input class="editable-text__input" 
				type="number"
				:value="hue" 
				@input="updateField($event, 'hue')" 
				:disabled="disable">
            <input class="editable-text__input" 
				type="number"
				:value="saturation" 
				@input="updateField($event, 'saturation')" 
				:disabled="disable">
            <input 
				class="editable-text__input" 
				type="number"
				:value="displayValue" 
				@input="updateField($event, 'value')" 
				:disabled="disable">
        </div>
    </div>
</template>

<script>
    import Color        from "../../../../../Lib/Color";
    import withinBounds from "../../../../../Lib/helpers/withinBounds";
    import BaseColorInput from "./BaseColorInput";
    import HsvBase        from "./HsvBase";

    export default {
        name : 'hsv-fields',
        extends: HsvBase,
        props: {
            disable: {
                default: false
            }
        },
    }
</script>